module.exports = __webpack_public_path__ + "img/9bf30d3e-5ec1-4180-9165-519f7b0765a4.81f3d434.webp";